export const UPDATE_SUCCESS_NOTIFICATION = 'CN Update Completed Successfully';
export const UPDATE_FAILED_NOTIFICATION = 'CN Update Failed';
export const PREVIEW_SUCCESS_NOTIFICATION =
  'CN Update Preview Successfully Generated';
export const PREVIEW_FAILED_NOTIFICATION = 'CN Update Preview Failed';



// WEBPACK FOOTER //
// ./src/pages/controlinformation/helpers/Constants.js